// This icon file is generated automatically.
var PExportOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.88 9.83h-.84a.12.12 0 00-.12.12v.97H1.08V1.08h9.84v.97c0 .06.05.12.12.12h.84c.07 0 .12-.06.12-.12V.48a.48.48 0 00-.48-.48H.48A.48.48 0 000 .48v11.04c0 .27.21.48.48.48h11.04c.27 0 .48-.21.48-.48V9.95a.12.12 0 00-.12-.12zm.29-3.93L9.95 4.15a.13.13 0 00-.2.1v1.19h-4.9a.13.13 0 00-.13.12v.88c0 .07.06.12.12.12h4.91v1.19c0 .1.12.16.2.1l2.22-1.75a.12.12 0 000-.2z", "fill-rule": "nonzero" } }] }, "name": "p-export", "theme": "outlined" };
export default PExportOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PExportOutlined.js
// module id = 3371
// module chunks = 0